import { render, staticRenderFns } from "./stay-case-app.vue?vue&type=template&id=3f2c6fe0&scoped=true"
import script from "./stay-case-app.vue?vue&type=script&lang=ts"
export * from "./stay-case-app.vue?vue&type=script&lang=ts"
import style0 from "./stay-case-app.vue?vue&type=style&index=0&id=3f2c6fe0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f2c6fe0",
  null
  
)

export default component.exports